import { Directive } from '@angular/core';

@Directive({
  selector: '[appOptionLabel]'
})
export class OptionLabelDirective { }
